import React, { useMemo, useState } from 'react';
import {
  Badge,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Group,
  Paper,
  ScrollArea,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Text,
  TextInput,
  Textarea,
  ThemeIcon,
  Timeline,
  Title,
} from '@mantine/core';
import {
  IconArrowLeft,
  IconCheck,
  IconChevronRight,
  IconClockHour4,
  IconFileDescription,
  IconFilter,
  IconGitBranch,
  IconInfoCircle,
  IconReceipt2,
  IconSearch,
  IconSend,
  IconShieldCheck,
  IconUser,
  IconX,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const approvalRequestsSeed = [
  {
    id: 'PR-2026-0104',
    title: 'Yeni personel için çalışma ekipmanı talebi',
    department: 'Bilgi İşlem',
    requester: 'Muhammed Selvi',
    requestDate: '2026-03-18',
    needByDate: '2026-03-25',
    status: 'PENDING_APPROVAL',
    priority: 'HIGH',
    totalAmount: 44300,
    currency: 'TRY',
    costCenter: 'Merkez Ofis / BT',
    approvalRule: '10.000 TL üzeri → Müdür + Finans Onayı',
    currentStep: 'Departman Müdürü Onayı',
    justification:
      'Yeni başlayan personelin iş başı yapacağı gün ekipmanların hazır edilmesi gerekmektedir.',
    note: 'Minimum 2 tedarikçiden teklif toplanması planlanıyor.',
    lines: [
      {
        id: 'LINE-1',
        lineNo: 1,
        description: 'Dell Latitude 15 Laptop',
        quantity: 1,
        uom: 'Adet',
        unitPrice: 42000,
        lineAmount: 42000,
        requiredDate: '2026-03-25',
      },
      {
        id: 'LINE-2',
        lineNo: 2,
        description: 'Laptop Çantası',
        quantity: 1,
        uom: 'Adet',
        unitPrice: 1750,
        lineAmount: 1750,
        requiredDate: '2026-03-25',
      },
      {
        id: 'LINE-3',
        lineNo: 3,
        description: 'Kablosuz Mouse',
        quantity: 1,
        uom: 'Adet',
        unitPrice: 550,
        lineAmount: 550,
        requiredDate: '2026-03-25',
      },
    ],
    approvals: [
      {
        stepNo: 1,
        role: 'Talep Sahibi',
        user: 'Muhammed Selvi',
        status: 'COMPLETED',
        actionDate: '2026-03-18 09:12',
        note: 'Talep oluşturuldu ve onaya gönderildi.',
      },
      {
        stepNo: 2,
        role: 'Departman Müdürü',
        user: 'Bekliyor',
        status: 'PENDING',
        actionDate: null,
        note: 'Tutar ve ihtiyaç tarihi kontrolü bekleniyor.',
      },
      {
        stepNo: 3,
        role: 'Finans',
        user: 'Bekliyor',
        status: 'WAITING',
        actionDate: null,
        note: 'Bütçe ve masraf merkezi kontrolü yapılacak.',
      },
    ],
  },
  {
    id: 'PR-2026-0105',
    title: 'Aylık kırtasiye ve sarf malzeme alımı',
    department: 'İdari İşler',
    requester: 'Ayşe Kaya',
    requestDate: '2026-03-17',
    needByDate: '2026-03-22',
    status: 'APPROVED',
    priority: 'MEDIUM',
    totalAmount: 12650,
    currency: 'TRY',
    costCenter: 'Genel Yönetim',
    approvalRule: '5.000 TL üzeri → Müdür Onayı',
    currentStep: 'Tamamlandı',
    justification: 'Ofis içi tüketim malzemeleri stok seviyesi kritik sınıra yaklaşmıştır.',
    note: 'Mevcut tedarikçiyle yıllık fiyat anlaşması mevcut.',
    lines: [
      {
        id: 'LINE-4',
        lineNo: 1,
        description: 'A4 Fotokopi Kağıdı',
        quantity: 20,
        uom: 'Koli',
        unitPrice: 450,
        lineAmount: 9000,
        requiredDate: '2026-03-22',
      },
      {
        id: 'LINE-5',
        lineNo: 2,
        description: 'Tükenmez Kalem',
        quantity: 50,
        uom: 'Adet',
        unitPrice: 18,
        lineAmount: 900,
        requiredDate: '2026-03-22',
      },
      {
        id: 'LINE-6',
        lineNo: 3,
        description: 'Dosya Klasörü',
        quantity: 25,
        uom: 'Adet',
        unitPrice: 110,
        lineAmount: 2750,
        requiredDate: '2026-03-22',
      },
    ],
    approvals: [
      {
        stepNo: 1,
        role: 'Talep Sahibi',
        user: 'Ayşe Kaya',
        status: 'COMPLETED',
        actionDate: '2026-03-17 10:02',
        note: 'Talep kaydı oluşturuldu.',
      },
      {
        stepNo: 2,
        role: 'Departman Müdürü',
        user: 'Can Yılmaz',
        status: 'COMPLETED',
        actionDate: '2026-03-17 11:20',
        note: 'İhtiyaç onaylandı.',
      },
    ],
  },
  {
    id: 'PR-2026-0106',
    title: 'Saha ekipleri için koruyucu ekipman takviyesi',
    department: 'Şantiye Operasyon',
    requester: 'Emre Demir',
    requestDate: '2026-03-16',
    needByDate: '2026-03-21',
    status: 'REJECTED',
    priority: 'CRITICAL',
    totalAmount: 29800,
    currency: 'TRY',
    costCenter: 'Şantiye / Operasyon',
    approvalRule: '20.000 TL üzeri → Operasyon Müdürü + Finans',
    currentStep: 'Reddedildi',
    justification: 'Yeni saha açılışı öncesi ekipman tamamlaması hedeflenmişti.',
    note: 'Alternatif stok kaynağı kontrol edilecek.',
    lines: [
      {
        id: 'LINE-7',
        lineNo: 1,
        description: 'Baret',
        quantity: 40,
        uom: 'Adet',
        unitPrice: 280,
        lineAmount: 11200,
        requiredDate: '2026-03-21',
      },
      {
        id: 'LINE-8',
        lineNo: 2,
        description: 'Reflektif Yelek',
        quantity: 40,
        uom: 'Adet',
        unitPrice: 280,
        lineAmount: 11200,
        requiredDate: '2026-03-21',
      },
      {
        id: 'LINE-9',
        lineNo: 3,
        description: 'Koruyucu Gözlük',
        quantity: 20,
        uom: 'Adet',
        unitPrice: 370,
        lineAmount: 7400,
        requiredDate: '2026-03-21',
      },
    ],
    approvals: [
      {
        stepNo: 1,
        role: 'Talep Sahibi',
        user: 'Emre Demir',
        status: 'COMPLETED',
        actionDate: '2026-03-16 08:45',
        note: 'Talep oluşturuldu.',
      },
      {
        stepNo: 2,
        role: 'Operasyon Müdürü',
        user: 'Murat Aksoy',
        status: 'REJECTED',
        actionDate: '2026-03-16 12:10',
        note: 'Merkez stokta mevcut ekipman olduğu tespit edildi.',
      },
    ],
  },
];

const currencyFormatter = new Intl.NumberFormat('tr-TR', {
  style: 'currency',
  currency: 'TRY',
  maximumFractionDigits: 2,
});

const statusConfig = {
  PENDING_APPROVAL: { label: 'Onay Bekliyor', color: 'orange', icon: IconClockHour4 },
  APPROVED: { label: 'Onaylandı', color: 'teal', icon: IconCheck },
  REJECTED: { label: 'Reddedildi', color: 'red', icon: IconX },
  WAITING: { label: 'Sırada', color: 'gray', icon: IconClockHour4 },
  PENDING: { label: 'İşlem Bekliyor', color: 'yellow', icon: IconClockHour4 },
  COMPLETED: { label: 'Tamamlandı', color: 'teal', icon: IconCheck },
};

const priorityConfig = {
  LOW: { label: 'Düşük', color: 'gray' },
  MEDIUM: { label: 'Orta', color: 'blue' },
  HIGH: { label: 'Yüksek', color: 'orange' },
  CRITICAL: { label: 'Kritik', color: 'red' },
};

function StatusBadge({ status }) {
  const config = statusConfig[status] || { label: status, color: 'gray', icon: IconFileDescription };
  const Icon = config.icon;

  return (
    <Badge variant="light" color={config.color} radius="sm" leftSection={<Icon size={14} />}>
      {config.label}
    </Badge>
  );
}

function SummaryCard({ title, value, subtitle, color, icon: Icon }) {
  return (
    <Card withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text size="sm" c="dimmed" fw={500}>
            {title}
          </Text>
          <Text fw={800} size="1.55rem" lh={1.1}>
            {value}
          </Text>
          <Text size="xs" c="dimmed">
            {subtitle}
          </Text>
        </Stack>
        <ThemeIcon color={color} variant="light" size={46} radius="md">
          <Icon size={22} />
        </ThemeIcon>
      </Group>
    </Card>
  );
}

function SectionCard({ title, description, children, action }) {
  return (
    <Paper withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start" mb="md">
        <div>
          <Title order={4}>{title}</Title>
          {description ? (
            <Text size="sm" c="dimmed" mt={4}>
              {description}
            </Text>
          ) : null}
        </div>
        {action}
      </Group>
      {children}
    </Paper>
  );
}

function InfoRow({ label, value }) {
  return (
    <>
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Text size="sm" c="dimmed">
          {label}
        </Text>
        <BoxValue value={value} />
      </Group>
      <Divider />
    </>
  );
}

function BoxValue({ value }) {
  return typeof value === 'string' || typeof value === 'number' ? (
    <Text size="sm" fw={600} ta="right">
      {value || '-'}
    </Text>
  ) : (
    value
  );
}

export default function ProcurementRequestApprovalPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [selectedId, setSelectedId] = useState(approvalRequestsSeed[0]?.id || '');
  const [decisionNote, setDecisionNote] = useState('Talep içeriği ve yaklaşık bütçe uygun görünüyor.');

  const filteredRequests = useMemo(() => {
    return approvalRequestsSeed.filter((item) => {
      const q = search.trim().toLowerCase();
      const matchesSearch =
        !q ||
        item.id.toLowerCase().includes(q) ||
        item.title.toLowerCase().includes(q) ||
        item.department.toLowerCase().includes(q) ||
        item.requester.toLowerCase().includes(q);

      const matchesStatus = statusFilter === 'ALL' ? true : item.status === statusFilter;
      return matchesSearch && matchesStatus;
    });
  }, [search, statusFilter]);

  const selectedRecord = useMemo(() => {
    const found = approvalRequestsSeed.find((item) => item.id === selectedId);
    return found || approvalRequestsSeed[0] || null;
  }, [selectedId]);

  const stats = useMemo(() => {
    return {
      pending: approvalRequestsSeed.filter((item) => item.status === 'PENDING_APPROVAL').length,
      approved: approvalRequestsSeed.filter((item) => item.status === 'APPROVED').length,
      rejected: approvalRequestsSeed.filter((item) => item.status === 'REJECTED').length,
      totalVolume: approvalRequestsSeed.reduce((acc, item) => acc + item.totalAmount, 0),
    };
  }, []);

  const columns = [
    { key: 'id', label: 'Talep No' },
    { key: 'title', label: 'Başlık' },
    { key: 'department', label: 'Departman' },
    { key: 'requester', label: 'Talep Eden' },
    {
      key: 'totalAmount',
      label: 'Tutar',
      render: (row) => <Text fw={600}>{currencyFormatter.format(row.totalAmount)}</Text>,
    },
    {
      key: 'priority',
      label: 'Öncelik',
      render: (row) => (
        <Badge variant="light" color={priorityConfig[row.priority]?.color || 'gray'}>
          {priorityConfig[row.priority]?.label || row.priority}
        </Badge>
      ),
    },
    {
      key: 'status',
      label: 'Durum',
      render: (row) => <StatusBadge status={row.status} />,
    },
  ];

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Paper
          withBorder
          radius="xl"
          p="xl"
          shadow="sm"
          style={{
            background: 'linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(255,255,255,1) 100%)',
          }}
        >
          <Group justify="space-between" align="flex-start" gap="xl">
            <Stack gap="sm" maw={860}>
              <Group gap="sm">
                <Button
                  variant="subtle"
                  leftSection={<IconArrowLeft size={16} />}
                  px={0}
                  onClick={() => navigate("/purchase-dashboard")}
                >
                  Geri Dön
                </Button>
                <Badge variant="light" color="orange" leftSection={<IconShieldCheck size={14} />}>
                  Statik demo onay ekranı
                </Badge>
              </Group>

              <div>
                <Title order={1}>Talep Onay Ekranı</Title>
                <Text size="sm" c="dimmed" mt="sm">
                  Bu ekran, oluşturulan taleplerin ilgili onay mercileri tarafından incelenmesi için hazırlandı.
                  Talep detayları, onay rotası, satır bazlı içerik ve karar notu aynı sayfada görünür.
                </Text>
              </div>
            </Stack>
          </Group>

          <SimpleGrid cols={{ base: 1, sm: 2, xl: 4 }} spacing="md" mt="xl">
            <SummaryCard
              title="Onay Bekleyen"
              value={stats.pending}
              subtitle="İşlem almayı bekleyen talepler"
              color="orange"
              icon={IconClockHour4}
            />
            <SummaryCard
              title="Onaylanan"
              value={stats.approved}
              subtitle="Süreci tamamlanmış talepler"
              color="teal"
              icon={IconCheck}
            />
            <SummaryCard
              title="Reddedilen"
              value={stats.rejected}
              subtitle="Gerekçe ile kapatılan talepler"
              color="red"
              icon={IconX}
            />
            <SummaryCard
              title="Toplam Hacim"
              value={currencyFormatter.format(stats.totalVolume)}
              subtitle="İncelenen talep büyüklüğü"
              color="blue"
              icon={IconReceipt2}
            />
          </SimpleGrid>
        </Paper>

        <Grid gutter="lg">
          <Grid.Col span={{ base: 12, xl: 3.5 }}>
            <Stack gap="md">
              <SectionCard title="Filtreler" description="Talep kuyruğunu hızlıca daraltın.">
                <Stack gap="sm">
                  <TextInput
                    placeholder="Talep no, başlık, departman ara..."
                    value={search}
                    onChange={(event) => setSearch(event.currentTarget.value)}
                    leftSection={<IconSearch size={16} />}
                  />
                  <Select
                    value={statusFilter}
                    onChange={(value) => setStatusFilter(value || 'ALL')}
                    data={[
                      { value: 'ALL', label: 'Tüm Durumlar' },
                      { value: 'PENDING_APPROVAL', label: 'Onay Bekliyor' },
                      { value: 'APPROVED', label: 'Onaylandı' },
                      { value: 'REJECTED', label: 'Reddedildi' },
                    ]}
                    leftSection={<IconFilter size={16} />}
                  />
                </Stack>
              </SectionCard>

              <SectionCard title="Onay Kuyruğu" description="Tıklayarak talep detayını sağ panelde inceleyin.">
                <Stack gap="xs">
                  {filteredRequests.length === 0 ? (
                    <Text size="sm" c="dimmed">
                      Filtreye uygun talep bulunamadı.
                    </Text>
                  ) : (
                    filteredRequests.map((item) => {
                      const active = selectedId === item.id;
                      return (
                        <Paper
                          key={item.id}
                          withBorder
                          radius="md"
                          p="sm"
                          style={{
                            cursor: 'pointer',
                            borderColor: active ? 'var(--mantine-color-blue-4)' : undefined,
                            backgroundColor: active ? 'var(--mantine-color-blue-0)' : undefined,
                          }}
                          onClick={() => setSelectedId(item.id)}
                        >
                          <Group justify="space-between" align="flex-start" wrap="nowrap">
                            <div>
                              <Text fw={700} size="sm">
                                {item.id}
                              </Text>
                              <Text size="sm" mt={2}>
                                {item.title}
                              </Text>
                              <Text size="xs" c="dimmed" mt={4}>
                                {item.department} • {item.requester}
                              </Text>
                            </div>
                            <Stack gap={6} align="flex-end">
                              <StatusBadge status={item.status} />
                              <Badge variant="dot" color={priorityConfig[item.priority]?.color || 'gray'}>
                                {priorityConfig[item.priority]?.label || item.priority}
                              </Badge>
                            </Stack>
                          </Group>
                        </Paper>
                      );
                    })
                  )}
                </Stack>
              </SectionCard>

              <SectionCard title="Süreç Özeti" description="Bu ekranın bir sonraki akış bağlantıları.">
                <Timeline active={1} bulletSize={24} lineWidth={2}>
                  <Timeline.Item bullet={<IconFileDescription size={14} />} title="Talep Oluşturuldu">
                    <Text c="dimmed" size="sm">Temel bilgiler ve kalemler giriş ekranında oluşturuldu.</Text>
                  </Timeline.Item>
                  <Timeline.Item bullet={<IconShieldCheck size={14} />} title="Onay Süreci">
                    <Text c="dimmed" size="sm">Bu sayfada yönetici ve finans kararı verilir.</Text>
                  </Timeline.Item>
                  <Timeline.Item bullet={<IconReceipt2 size={14} />} title="Teklif Toplama">
                    <Text c="dimmed" size="sm">Onaylanan talep için tedarikçi teklifleri girilir.</Text>
                  </Timeline.Item>
                </Timeline>
              </SectionCard>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, xl: 8.5 }}>
            <Stack gap="lg">
              <SectionCard
                title="Talep Listesi"
                description="Onay sürecindeki taleplerin tablo görünümü."
                action={
                  <Group>
                    <Button variant="default" leftSection={<IconSearch size={16} />}>
                      Filtrele
                    </Button>
                    <Button variant="light" leftSection={<IconSend size={16} />}>
                      Toplu İşlem
                    </Button>
                  </Group>
                }
              >
                <ScrollArea>
                  <Table highlightOnHover striped verticalSpacing="sm" horizontalSpacing="md">
                    <Table.Thead>
                      <Table.Tr>
                        {columns.map((column) => (
                          <Table.Th key={column.key}>{column.label}</Table.Th>
                        ))}
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {filteredRequests.map((row) => (
                        <Table.Tr
                          key={row.id}
                          onClick={() => setSelectedId(row.id)}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: selectedId === row.id ? 'var(--mantine-color-gray-0)' : undefined,
                          }}
                        >
                          {columns.map((column) => (
                            <Table.Td key={column.key}>
                              {column.render ? column.render(row) : row[column.key]}
                            </Table.Td>
                          ))}
                        </Table.Tr>
                      ))}
                    </Table.Tbody>
                  </Table>
                </ScrollArea>
              </SectionCard>

              {selectedRecord && (
                <>
                  <SimpleGrid cols={{ base: 1, xl: 2 }} spacing="md">
                    <SectionCard title="Talep Özeti" description="Seçili kaydın temel alanları.">
                      <Stack gap="sm">
                        <InfoRow label="Talep No" value={selectedRecord.id} />
                        <InfoRow label="Başlık" value={selectedRecord.title} />
                        <InfoRow label="Departman" value={selectedRecord.department} />
                        <InfoRow label="Talep Eden" value={selectedRecord.requester} />
                        <InfoRow label="Talep Tarihi" value={selectedRecord.requestDate} />
                        <InfoRow label="İhtiyaç Tarihi" value={selectedRecord.needByDate} />
                        <InfoRow label="Masraf Merkezi" value={selectedRecord.costCenter} />
                        <InfoRow
                          label="Öncelik"
                          value={
                            <Badge color={priorityConfig[selectedRecord.priority]?.color || 'gray'} variant="light">
                              {priorityConfig[selectedRecord.priority]?.label || selectedRecord.priority}
                            </Badge>
                          }
                        />
                        <InfoRow label="Tutar" value={currencyFormatter.format(selectedRecord.totalAmount)} />
                        <InfoRow label="Onay Kuralı" value={selectedRecord.approvalRule} />
                        <InfoRow label="Mevcut Adım" value={selectedRecord.currentStep} />
                      </Stack>
                    </SectionCard>

                    <SectionCard title="Karar Alanı" description="Onaycı notu ve görsel aksiyon butonları.">
                      <Stack gap="md">
                        <Paper withBorder radius="md" p="sm" bg="gray.0">
                          <Group justify="space-between" align="center">
                            <Group gap="xs">
                              <ThemeIcon color="orange" variant="light" radius="md">
                                <IconGitBranch size={16} />
                              </ThemeIcon>
                              <div>
                                <Text fw={700} size="sm">
                                  Aktif Onay Adımı
                                </Text>
                                <Text size="xs" c="dimmed">
                                  {selectedRecord.currentStep}
                                </Text>
                              </div>
                            </Group>
                            <StatusBadge status={selectedRecord.status} />
                          </Group>
                        </Paper>

                        <Textarea
                          label="Karar Notu"
                          minRows={5}
                          value={decisionNote}
                          onChange={(event) => setDecisionNote(event.currentTarget.value)}
                        />

                        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
                          <Button color="teal" leftSection={<IconCheck size={16} />}>
                            Talebi Onayla
                          </Button>
                          <Button color="red" variant="light" leftSection={<IconX size={16} />}>
                            Talebi Reddet
                          </Button>
                        </SimpleGrid>

                        <Button variant="default" leftSection={<IconChevronRight size={16} />}>
                          Sonraki Aşamayı Simüle Et
                        </Button>
                      </Stack>
                    </SectionCard>
                  </SimpleGrid>

                  <SectionCard title="Talep Gerekçesi ve Açıklamalar" description="Onay kararını destekleyen metinsel alanlar.">
                    <Stack gap="sm">
                      <Paper withBorder radius="md" p="sm">
                        <Text size="sm" c="dimmed" mb={4}>
                          Talep Gerekçesi
                        </Text>
                        <Text size="sm">{selectedRecord.justification}</Text>
                      </Paper>
                      <Paper withBorder radius="md" p="sm">
                        <Text size="sm" c="dimmed" mb={4}>
                          Ek Not
                        </Text>
                        <Text size="sm">{selectedRecord.note}</Text>
                      </Paper>
                    </Stack>
                  </SectionCard>

                  <SimpleGrid cols={{ base: 1, xl: 2 }} spacing="md">
                    <SectionCard title="Talep Kalemleri" description="Onay öncesi satır bazlı inceleme görünümü.">
                      <ScrollArea>
                        <Table verticalSpacing="sm" horizontalSpacing="md" striped>
                          <Table.Thead>
                            <Table.Tr>
                              <Table.Th>#</Table.Th>
                              <Table.Th>Açıklama</Table.Th>
                              <Table.Th>Miktar</Table.Th>
                              <Table.Th>Birim</Table.Th>
                              <Table.Th>Tarih</Table.Th>
                              <Table.Th>Tutar</Table.Th>
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {selectedRecord.lines.map((line) => (
                              <Table.Tr key={line.id}>
                                <Table.Td>{line.lineNo}</Table.Td>
                                <Table.Td>{line.description}</Table.Td>
                                <Table.Td>{line.quantity}</Table.Td>
                                <Table.Td>{line.uom}</Table.Td>
                                <Table.Td>{line.requiredDate}</Table.Td>
                                <Table.Td>
                                  <Text fw={600}>{currencyFormatter.format(line.lineAmount)}</Text>
                                </Table.Td>
                              </Table.Tr>
                            ))}
                          </Table.Tbody>
                        </Table>
                      </ScrollArea>
                    </SectionCard>

                    <SectionCard title="Onay Akışı" description="Oluşan approval step kurgusunun demo görünümü.">
                      <Timeline active={selectedRecord.approvals.findIndex((item) => item.status === 'PENDING')} bulletSize={24} lineWidth={2}>
                        {selectedRecord.approvals.map((step) => {
                          const cfg = statusConfig[step.status] || { color: 'gray', icon: IconClockHour4, label: step.status };
                          const Icon = cfg.icon;
                          return (
                            <Timeline.Item
                              key={`${selectedRecord.id}-${step.stepNo}`}
                              bullet={<Icon size={14} />}
                              color={cfg.color}
                              title={`${step.stepNo}. ${step.role}`}
                            >
                              <Stack gap={4}>
                                <Group gap="xs">
                                  <ThemeIcon size="sm" variant="light" color={cfg.color} radius="xl">
                                    <IconUser size={12} />
                                  </ThemeIcon>
                                  <Text size="sm">{step.user}</Text>
                                  <StatusBadge status={step.status} />
                                </Group>
                                <Text size="xs" c="dimmed">
                                  {step.actionDate || 'Henüz işlem yapılmadı'}
                                </Text>
                                <Text size="sm" c="dimmed">
                                  {step.note}
                                </Text>
                              </Stack>
                            </Timeline.Item>
                          );
                        })}
                      </Timeline>
                    </SectionCard>
                  </SimpleGrid>
                </>
              )}
            </Stack>
          </Grid.Col>
        </Grid>

        <Paper withBorder radius="lg" p="md" shadow="sm" style={{ borderStyle: 'dashed' }}>
          <Group align="flex-start" wrap="nowrap">
            <ThemeIcon color="blue" variant="light" mt={2}>
              <IconInfoCircle size={16} />
            </ThemeIcon>
            <Text size="sm" c="dimmed">
              Sonraki aşamada bu ekran için gerçek onay aksiyonları, rol bazlı görünürlük, bütçe kontrol uyarıları,
              çok seviyeli approval adımları ve onay sonrası otomatik teklif toplama ekranına yönlendirme eklenebilir.
            </Text>
          </Group>
        </Paper>
      </Stack>
    </Container>
  );
}
